import React, {Component} from 'react';
import {Form, message, Spin} from 'antd';
import {connect} from 'react-redux'
import {API_URL, logout, setToken, verifyLoginAs} from '../../../actions/authActions'
import setAuthorizationToken from '../../../utils/setAuthorizationToken'
import {decode} from '../../../utils/crypt'
import axios from "axios";


class LoginAs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: false,
            loading:false
        }
    }
    goTo(route) {
        this.props.history.replace(`${route}`)
    }

    componentWillMount(){
        let token = this.props.match.params.token || ''
        if(token) {

            this.props.logout()
            this.setState({loading: true})
            setAuthorizationToken(decode(token))

            verifyLoginAs().then(response => {
                const data = response.data.data.user;
                setAuthorizationToken(data.accessToken);
                axios.get(API_URL + '/user/verify-token', {
                    headers: {
                        "authorization": data.accessToken
                    }
                }).then(res => {
                    if (res.data.data) {
                        this.props.setToken(data.accessToken, res.data.data)
                        message.success('Login successfully!');
                        this.setState({loading: false})
                        window.location.href = '/';
                    }
                })
            })
        }
    }

    render() {

        return (
           <div><Spin loading={this.state.loading}></Spin></div>

        );
    }
}


const WrappedLoginForm = Form.create()(LoginAs);

const mapStateToProps = (state) => {
    return {
        isAuthenticated:state.auth.isAuthenticated
    }
}
export default connect(mapStateToProps, {setToken,logout})(WrappedLoginForm)






// WEBPACK FOOTER //
// ./src/components/Settings/Login/LoginAs.js